import moment from "moment";

const Checkbox = (props) => {
  const data = props.data;
  return (
    <>
      <div className="col-md-3 flex">
        <label htmlFor={data.name}>
          {data.label}{" "}
          {data?.required && <span className="text-danger">*</span>}
        </label>

        <br />
        <input
          class="form-check-input"
          type={data.type}
          name={data.name}
          id={data.name}
          checked={props.isChecked}
          // value={props.state[data.name]}
          onChange={(e) => props.handleInput(e)}
        ></input>
      </div>
    </>
  );
};

export default Checkbox;
